import { track } from '../../analytics/events';

export const desktopAnalytics = () => ({
  // FORM EVENTS
  form: {
    submitted: () => track('FormSubmitted', {
      formType: 'VERIFY_INFO_EDIT',
      formName: 'VERIFY_INFO_EDIT',
    }),
  },

  // INPUT EVENTS
  input: {
    familySameLastName: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-same-last-name',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    familyRemaining: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-remaining',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    businessWholeCompany: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'business-whole-company',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    businessName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'business-name',
        fieldLabel: 'Business Name',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    /**
     * @param {String} num - Business Alias number
     */
    businessAlias: (num) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: `business-alias-${num}`,
        fieldLabel: `Business Alias ${num}`,
      },
      formContext: {
        formName: 'BUSINESS_ALIASES',
      },
    }),
    firstName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'first-name',
        fieldLabel: 'First Name',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    lastName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'last-name',
        fieldLabel: 'Last Name',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    email: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'EMAIL',
        fieldName: 'email',
        fieldLabel: 'Email Address',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    emailConfirm: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'EMAIL',
        fieldName: 'email-confirm',
        fieldLabel: 'Confirm Email Address',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    phone: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'PHONE',
        fieldName: 'phone',
        fieldLabel: 'Phone Number',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    phoneType: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'phone-type',
        fieldLabel: 'Phone Type',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    startDate: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DATE',
        fieldName: 'forward-start-date',
        fieldLabel: 'Start Forwarding',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    stopDate: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DATE',
        fieldName: 'forward-stop-date',
        fieldLabel: 'End Forwarding',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'old-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'new-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newPrivateMailbox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-private-mailbox',
        fieldLabel: 'Private Mailbox',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
  },

  // CLICK EVENTS
  click: {
    moverType: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value,
      },
      actionOutcome: 'MOVER_TYPE',
    }),
    familyModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'FAMILY_MODAL_OPENED',
    }),
    familyModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'FAMILY_MODAL_CLOSED',
    }),
    businessModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'BUSINESS_MODAL_OPENED',
    }),
    businessModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'BUSINESS_MODAL_CLOSED',
    }),
    businessAliases: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Business Aliases',
      },
      actionOutcome: `${on ? 'SHOW' : 'HIDE'}`,
    }),
    emailOptOutModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'click here',
      },
      actionOutcome: 'EMAIL_OPT_OUT_MODAL_OPENED',
    }),
    emailOptOutModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Close',
      },
      actionOutcome: 'EMAIL_OPT_OUT_MODAL_CLOSED',
    }),
    optInReminder: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'Opt In Reminder Email',
      },
      actionOutcome: `TOGGLE_${on ? 'ON' : 'OFF'}`,
    }),
    forwardType: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value,
      },
      actionOutcome: 'FORWARD_TYPE',
    }),
    newConstructionModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: '',
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_OPENED',
    }),
    newConstructionModalClose: (text) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text,
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_CLOSED',
    }),
    save: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Save',
      },
      actionOutcome: 'SUBMIT',
    }),
    recaptchaVerified: () => track('FieldInteracted', {
      webElement: {
        elementType: 'BUTTON',
        text: 'recaptcha-verified',
      },
      actionOutcome: 'INTERNALLINK',
    }),
  },
});

export const mobileAnalytics = () => ({
  // FORM EVENTS
  form: {
    submitted: () => track('FormSubmitted', {
      formType: 'VERIFY_INFO_EDIT',
      formName: 'VERIFY_INFO_EDIT',
    }),
  },

  // INPUT EVENTS
  input: {
    familySameLastName: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-same-last-name',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    familyRemaining: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'family-remaining',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    businessWholeCompany: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'RADIO',
        fieldName: 'business-whole-company',
        fieldLabel: value,
        fieldValue: value,
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    businessName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'business-name',
        fieldLabel: 'Business Name',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    /**
     * @param {String} num - Business Alias number
     */
    businessAlias: (num) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: `business-alias-${num}`,
        fieldLabel: `Business Alias ${num}`,
      },
      formContext: {
        formName: 'BUSINESS_ALIASES',
      },
    }),
    firstName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'first-name',
        fieldLabel: 'First Name',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    lastName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'last-name',
        fieldLabel: 'Last Name',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    email: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'EMAIL',
        fieldName: 'email',
        fieldLabel: 'Email Address',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    emailConfirm: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'EMAIL',
        fieldName: 'email-confirm',
        fieldLabel: 'Confirm Email Address',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    phone: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'PHONE',
        fieldName: 'phone',
        fieldLabel: 'Phone Number',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    phoneType: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'phone-type',
        fieldLabel: 'Phone Type',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    startDate: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DATE',
        fieldName: 'forward-start-date',
        fieldLabel: 'Start Forwarding',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    stopDate: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DATE',
        fieldName: 'forward-stop-date',
        fieldLabel: 'End Forwarding',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'old-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    oldPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'old-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newZipCode: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-zip-code',
        fieldLabel: 'Zip Code',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newCity: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-city',
        fieldLabel: 'City',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newState: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'new-state',
        fieldLabel: 'State',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newStreet: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-street-address',
        fieldLabel: 'Street Address',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newUrbanizationName: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-urbanization-name',
        fieldLabel: 'Urbanization Name',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newPoBox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-po-box',
        fieldLabel: 'Po Box',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
    newPrivateMailbox: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'TEXT',
        fieldName: 'new-private-mailbox',
        fieldLabel: 'Private Mailbox',
      },
      formContext: {
        formName: 'VERIFY_INFO_EDIT',
      },
    }),
  },

  // CLICK EVENTS
  click: {
    moverType: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value,
      },
      actionOutcome: 'MOVER_TYPE',
    }),
    familyModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'FAMILY_MODAL_OPENED',
    }),
    familyModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'FAMILY_MODAL_CLOSED',
    }),
    businessModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'RADIO',
        text: '',
      },
      actionOutcome: 'BUSINESS_MODAL_OPENED',
    }),
    businessModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Continue',
      },
      actionOutcome: 'BUSINESS_MODAL_CLOSED',
    }),
    businessAliases: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Business Aliases',
      },
      actionOutcome: `${on ? 'SHOW' : 'HIDE'}`,
    }),
    emailOptOutModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'click here',
      },
      actionOutcome: 'EMAIL_OPT_OUT_MODAL_OPENED',
    }),
    emailOptOutModalClose: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Close',
      },
      actionOutcome: 'EMAIL_OPT_OUT_MODAL_CLOSED',
    }),
    optInReminder: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'Opt In Reminder Email',
      },
      actionOutcome: `TOGGLE_${on ? 'ON' : 'OFF'}`,
    }),
    forwardType: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value,
      },
      actionOutcome: 'FORWARD_TYPE',
    }),
    newConstructionModalOpen: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: '',
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_OPENED',
    }),
    newConstructionModalClose: (text) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text,
      },
      actionOutcome: 'NEW_CONSTRUCTION_MODAL_CLOSED',
    }),
    save: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Save',
      },
      actionOutcome: 'SUBMIT',
    }),
    tooltipMoveType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-move-type',
      },
      actionOutcome: '',
    }),
    tooltipName: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-name',
      },
      actionOutcome: '',
    }),
    tooltipEmail: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-email',
      },
      actionOutcome: '',
    }),
    tooltipForwardType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-forward-type',
      },
      actionOutcome: '',
    }),
    tooltipForwardStartDate: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-forward-start-date',
      },
      actionOutcome: '',
    }),
    tooltipOldAddress: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-old-address',
      },
      actionOutcome: '',
    }),
    tooltipNewAddress: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'tooltip-new-address',
      },
      actionOutcome: '',
    }),
    recaptchaVerified: () => track('FieldInteracted', {
      webElement: {
        elementType: 'BUTTON',
        text: 'recaptcha-verified',
      },
      actionOutcome: 'INTERNALLINK',
    }),
  },
});
